"use client";

import { ReadMore, ReadMoreProps } from "@silversea-ssc/ui-components-react";
import { PropsWithChildren } from "react";

type Props = Omit<ReadMoreProps, "openLabel" | "closeLabel">;

const ClientReadMore: React.FC<PropsWithChildren<Props>> = ({
  children,
  ...props
}) => {
  return (
    <ReadMore {...props} openLabel="Read more" closeLabel="Read less">
      {children}
    </ReadMore>
  );
};
export default ClientReadMore;
